
import { XMarkIcon } from "@heroicons/vue/20/solid";
import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
} from "@heroicons/vue/24/outline";
import { defineComponent } from "vue";

export default defineComponent({
  name: "CustomNotifications",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    alert: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  emits: ["closeAlert"],
  components: {
    ExclamationTriangleIcon,
    InformationCircleIcon,
    XMarkIcon,
    CheckCircleIcon,
  },
});
